import { render, staticRenderFns } from "./PageIndex.vue?vue&type=template&id=4d6448f6&scoped=true&"
import script from "./PageIndex.vue?vue&type=script&lang=js&"
export * from "./PageIndex.vue?vue&type=script&lang=js&"
import style0 from "./PageIndex.vue?vue&type=style&index=0&id=4d6448f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6448f6",
  null
  
)

export default component.exports